import ApiJobLanguage from 'types/api/JobLanguage';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobLanguage from 'models/JobLanguage';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobLanguage>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobLanguages, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobLanguages];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobLanguage) => new JobLanguage(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobLanguage> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobLanguage, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobLanguage = data && data[ApiResources.JobLanguage];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobLanguage(resource);
};
